var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19056_10390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.25 0C0.560547 0 0 0.560547 0 1.25V6.875C0 7.56445 0.560547 8.125 1.25 8.125H3.125V9.6875C3.125 9.80664 3.19141 9.91406 3.29688 9.9668C3.40234 10.0195 3.5293 10.0078 3.625 9.9375L6.04102 8.125H8.75C9.43945 8.125 10 7.56445 10 6.875V1.25C10 0.560547 9.43945 0 8.75 0H1.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19056_10390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.d8d1e177484b6bd1a9fe678ec12c15bb.svg";
export { ForwardRef as ReactComponent };